import { sample } from 'effector';
import { signout } from '@features/common';
import { SortConfig } from '../../types';
import {
  $config,
  $error,
  clearError,
  errorOccured,
  fxGetStorage,
  fxUpdateStorage,
  saveSortToStorage,
  setConfig,
  setSortingReady,
  SortToolbarGate,
} from '../model';

export const storage = () => {
  $error
    .on(errorOccured, (_, data) => {
      const { error } = data;

      if (typeof error.message === 'string') return error;

      return JSON.parse(error.message ?? '{}');
    })
    .reset([SortToolbarGate.close, signout, clearError]);

  /** Запрашиваю сохраненную сортировку */
  sample({
    clock: setConfig,
    fn: (config) => ({ storage_key: config!.id }),
    target: fxGetStorage,
  });

  /** Записываю в default конфига сохраненную сортировку */
  sample({
    clock: fxGetStorage.doneData,
    source: $config,
    filter: (config, data) => !!config && !!data?.[0].field,
    fn: (config, data) =>
      ({
        ...config,
        default: {
          column: data?.[0].field,
          order: data?.[0].sort,
        },
      }) as SortConfig,
    target: $config,
  });

  /** Сигнал завершения загрузки сортировки из storage */
  sample({
    clock: fxGetStorage.finally,
    fn: () => true,
    target: setSortingReady,
  });

  /** Сохраняю новую сортировку */
  sample({
    clock: saveSortToStorage,
    source: $config,
    filter: (config) => !!config?.id,
    fn: (config, data) => ({
      storage_key: config!.id,
      data,
    }),
    target: fxUpdateStorage,
  });
};
